export default {
  en: {
    sendEmail: 'Send Email',
    senderName: 'Sender Name',
    otherSenderName: '- Other -',
    replyEmail: 'Reply Email',
    toEmail: 'To',
    ccEmail: 'Cc',
    bccEmail: 'Bcc',
    subject: 'Subject',
    body: 'Body',
    attachment: 'Attachment',
    cancel: 'Cancel',
    sendEmailContractSuccessTitle: 'Success',
    sendEmailContractSuccessMessage: 'Send email contract success',
    addEmail: 'Add Email',
    useCommaToSeparateEmailMessage: ' * use , to separate email',
    pleaseEnterToEmail: 'Please enter email to.',
    pleaseEnterEmailSubject: 'Please enter email subject',
    pleaseEnterEmailBody: 'Please enter email body'
  },
  th: {
    sendEmail: 'ส่งอีเมล',
    senderName: 'ชื่อผู้ส่ง',
    otherSenderName: '- อื่นๆ -',
    replyEmail: 'อีเมลตอบกลับ',
    toEmail: 'ส่งถึง',
    ccEmail: 'Cc',
    bccEmail: 'Bcc',
    subject: 'หัวข้อเรื่อง',
    body: 'เนื้อหา',
    attachment: 'เอกสารแนบ',
    cancel: 'ยกเลิก',
    sendEmailContractSuccessTitle: 'สำเร็จ',
    sendEmailContractSuccessMessage: 'ส่งอีเมลสัญญาสำเร็จ',
    addEmail: 'เพิ่มอีเมล',
    useCommaToSeparateEmailMessage: ' * ใช้เครื่องหมาย , เพื่อแบ่งอีเมล',
    pleaseEnterToEmail: 'กรุณาใส่อีเมลที่ต้องการส่งถึง',
    pleaseEnterEmailSubject: 'กรุณาใส่หัวข้อเรื่องอีเมล',
    pleaseEnterEmailBody: 'กรุณาใส่เนื้อหาอีเมล'
  }
}
